const STORAGE_KEY = 'atividades.progress.v1';

interface ProgressMap {
  [activityId: string]: {
    highestLevelCompleted: number;
    totalCorrect: number;
    lastPlayedAt: number;
  };
}

function load(): ProgressMap {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    return JSON.parse(raw) as ProgressMap;
  } catch {
    return {};
  }
}

function save(map: ProgressMap): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
  } catch {
    /* localStorage indisponível (modo privado) — segue silencioso */
  }
}

export function getHighestLevel(activityId: string): number {
  return load()[activityId]?.highestLevelCompleted ?? 0;
}

export function recordCompletion(activityId: string, level: number, correct: number): void {
  const map = load();
  const prev = map[activityId];
  map[activityId] = {
    highestLevelCompleted: Math.max(prev?.highestLevelCompleted ?? 0, level),
    totalCorrect: (prev?.totalCorrect ?? 0) + correct,
    lastPlayedAt: Date.now(),
  };
  save(map);
}

export function resetProgress(): void {
  save({});
}
